// extracted by mini-css-extract-plugin
export default {"grid":"GameCardsGrid__grid--slots-bncUB","component":"GameCardsGrid__component--slots-E63c9","item":"GameCardsGrid__item--slots-bLx9W"};